import React, { Component } from 'react';
import Slide from './Slide';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class Testimonials extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeSlide: 0,
      activeSlide2: 0
    };
  }

  render () {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 6000,
      // beforeChange: (current, next) => this.setState({ activeSlide: next }),
      afterChange: current => this.setState({ activeSlide2: current })
    };

    const slides = this.props.slides;
    const Susan = 'When my husband was diagnosed with cancer, I was overwhelmed and turned to a CDPHP case manager for help. She’s been my rock throughout this journey, and I don’t know what I would have done without her compassion and expertise.';
    const George = 'The team at CDPHP doesn’t treat you like random person number 437. They treat you like someone who they know and care about.';
    const Annie = 'I don’t know what I would have done without CDPHP. My nurse case manager checked in regularly throughout my pregnancy to check on my diabetes–and provide me with the tools, technology and coverage to help me take good care of myself.';
    const Johna = 'My dad was having a problem with fluid retention around his heart. It used to be a constant struggle to determine where and when it was best to get him treatment. But now, with 24/7 on-call and in-home care from CDPHP, his condition is well managed and we have peace of mind.';
    const smallBiz01 = 'CDPHP is there for my team.';
    const smallBiz02 = 'I have peace of mind with CDPHP.';
    const smallBiz03 = 'CDPHP is there for me and my team.';

    let testimonials = '';
    switch (slides) {
      case 'general':
        testimonials = (
          <Slider {...settings}>
            <Slide
              side='right'
              num='susan'
              name='Susan L.'
              quote={Susan} />
            <Slide
              side='left' num='george'
              name='George K.'
              quote={George} />
            <Slide
              side='right'
              num='annie'
              name='Annie M.'
              quote={Annie} />
          </Slider>
        );
        break;
      case 'medicare':
        testimonials = (
          <Slider {...settings}>
            <Slide
              side='right'
              num='johna'
              name='Johna P.'
              quote={Johna} />
            <Slide
              side='left' num='susan'
              name='Susan L.'
              quote={Susan} />
            <Slide
              side='right'
              num='george'
              name='George K.'
              quote={George} />
          </Slider>
        );
        break;
      case 'consumer':
        testimonials = (
          <Slider {...settings}>
            <Slide
              side='right'
              num='johna'
              name='Johna P.'
              quote={Johna} />
            <Slide
              side='left' num='george'
              name='George K.'
              quote={George} />
            <Slide
              side='right'
              num='susan'
              name='Susan L.'
              quote={Susan} />
          </Slider>
        );
        break;
      case 'group':
        testimonials = (
          <Slider {...settings}>
            <Slide
              side='right'
              num='annie'
              name='Annie M.'
              quote={Annie} />
            <Slide
              side='left' num='george'
              name='George K.'
              quote={George} />
            <Slide
              side='right'
              num='susan'
              name='Susan L.'
              quote={Susan} />
          </Slider>
        );
        break;
      case 'smallbiz':
        testimonials = (
          <Slider {...settings}>
            <Slide
              side='left smallbiz-slide'
              num='dbach'
              name='David Bach'
              title='President & CEO'
              company='Unity House'
              website='https://www.unityhouseny.org/'
              location='Troy, NY'
              quote={smallBiz03} />
            <Slide
              side='right smallbiz-slide'
              num='mharrison'
              name='Matt Harrison'
              title='Owner'
              company='Harrison Physical Therapy'
              website='https://www.harrisonpt.com/'
              location='Fishkill, NY'
              quote={smallBiz01} />
            <Slide
              side='left smallbiz-slide'
              num='lcruz'
              name='Liz Cruz'
              title='Office & Marketing Manager'
              company='Moroney’s Harley Davidson'
              website='https://www.fasthog.com/'
              location='New Windsor, NY'
              quote={smallBiz02} />
          </Slider>
        );
        break;
      default:
        testimonials = (
          <Slider {...settings}>
            <Slide
              side='right'
              num='susan'
              name='Susan L.'
              quote={Susan} />
            <Slide
              side='left'
              num='george'
              name='George K.'
              quote={George} />
            <Slide
              side='right'
              num='johna'
              name='Johna P.'
              quote={Johna} />
            <Slide
              side='left' num='annie'
              name='Annie M.'
              quote={Annie} />
          </Slider>
        );
        break;
    }

    return (
      <section id='testimonials' className={this.props.smallBiz ? 'small-biz-testimonial divide p60' : 'divide p60'}>
        <div className='wrap'>
          <h2>{this.props.heading}</h2>
          {this.props.smallBiz ? <h4>Our customers say the nicest things.</h4> : <h4>Our members say the nicest things.</h4>}
          <div className='slider'>
            {testimonials}
          </div>
          {this.props.children}
        </div>
      </section>
    );
  }
}

export default Testimonials;
